import React from "react";
import { USER_1_KOKORIN, USER_2_KOROVCHENO } from "../../config/trainers";
import { buildApiUrl } from "../../config/api";

const trainers = [
  { id: USER_1_KOKORIN.id, name: "Кокорін Ілля", role: "Силові та функціональні тренування", image: "/img/IMG_3668.JPG" },
  { id: USER_2_KOROVCHENO.id, name: "Коровчено Каріна", role: "Персональний супровід та техніка", image: "/img/IMG_5596.JPG" },
];

export default function Persons({ currentUser, serCurrentUser }) {
  const [textComment, setTextComment] = React.useState(null);
  React.useEffect(() => {
    let active = true;
    fetch(buildApiUrl("/api/text"))
      .then((res) => res.ok ? res.json() : null)
      .then((data) => { if (active) setTextComment(data?.text || null); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return (
    <section className="studio-trainers" aria-labelledby="trainers-title">
      <div className="booking-section-heading"><span className="step-number">01</span><div><p>ПОЧНЕМО З КОМАНДИ</p><h2 id="trainers-title">Обери свого тренера</h2></div></div>
      <div className="trainer-options">
        {trainers.map((trainer) => (
          <button type="button" key={trainer.id} className={`trainer-option${currentUser === trainer.id ? " is-selected" : ""}`}
            aria-pressed={currentUser === trainer.id} onClick={() => serCurrentUser(trainer.id)}>
            <img src={trainer.image} alt="" />
            <span className="trainer-option-copy"><span className="trainer-option-tag">{currentUser === trainer.id ? "ТВІЙ ТРЕНЕР" : "ОБРАТИ ТРЕНЕРА"}</span><strong>{trainer.name}</strong><span>{trainer.role}</span></span>
            <span className="selection-mark" aria-hidden="true">{currentUser === trainer.id ? "✓" : "+"}</span>
          </button>
        ))}
      </div>
      {textComment && <aside className="studio-policy"><span className="policy-icon" aria-hidden="true">i</span><div><h3>Плануй свій час з турботою</h3><p>{textComment}</p></div></aside>}
    </section>
  );
}
